import React, { useState } from 'react';
import Rules from './Rules';
import { useAppContext } from './AppContext';

const HomePage: React.FC = () => {
  const { loginData } = useAppContext();
  const [showRules, setShowRules] = useState(false);

  const openRules = () => {
    setShowRules(true);
  };

  const closeRules = () => {
    setShowRules(false);
  };

  return loginData == null ? ( <></> ) : (
    <>
      <div className="grid grid-cols-1 grid-rows-5 justify-center items-center h-full px-8">

        {/* Background Image */}
        {/*
        <div
          className="absolute inset-0 bg-cover bg-center opacity-50"
          style={{
            backgroundImage: `url(${TokenBG})`,
          }}
        ></div>
        */}

        {/* Rules Button */}
        <div className="flex justify-end">
          <button
            className="bg-white p-4 w-40 rounded-2xl border-2 border-black shadow-lg hover:bg-gray-100 cursor-pointer"
            onClick={openRules}
          >
            Rules
          </button>
        </div>

        {/* Left Positioned Text */}
        <div className="">
          <p className="text-lg">Base FM: {parseFloat((loginData.baseMultiplier).toFixed(2))}</p>
          <p className="text-lg">FM Limit: {parseFloat((loginData.baseMultiplier * 10).toFixed(2))}</p>
        </div>

        {/* Centered Text */}
        <div className="text-black text-4xl font-bold text-center">
          {parseFloat((loginData.pointsTotal).toFixed(2))} NAP
        </div>
        
      </div>

      {/* Modal sequence for Rules */}
      {showRules && <Rules onClose={closeRules} />}

    </>
  );
};

export default HomePage;